export default __webpack_public_path__ + "static/media/COMP.c52d1477.jpg";